import { Clipboard } from '@angular/cdk/clipboard';
import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[ngxClickToCopy]',
})
export class ClickToCopyDirective {

  @Input() ngxClickToCopy?: string;
  @Output() readonly copied = new EventEmitter();
  @HostBinding('class') @Input() additionalClasses = 'text-underline pointer';

  constructor(private readonly clipBoard: Clipboard) { }

  @HostListener('click') copy(): void {
    if (!this.ngxClickToCopy) {
      return;
    }

    if (this.clipBoard.copy(this.ngxClickToCopy)) {
      this.copied.emit();
    }
  }
}
